<template>
    <div>
        <h6 class="heading-small text-muted mb-4">Released By Signature</h6>
        <b-row v-if="!!order.warehouse_signature_data">
            <img :src="order.warehouse_signature_data" />
        </b-row>
        <div v-else style="padding: 5em 0; text-align: center">
            No Signature Image
        </div>
        <hr />
        <b-row class="pt-2" v-if="order.warehouse_signee">
            <b-col cols="2">
                <strong>Signee:</strong>
            </b-col>
            <b-col>{{ order.warehouse_signee }}</b-col>
        </b-row>
        <b-row class="pt-2" v-if="order.warehouse_signed_address">
            <b-col cols="2">
                <strong>Signed At:</strong>
            </b-col>
            <b-col>{{ order.warehouse_signed_address }}</b-col>
        </b-row>
        <b-row class="pt-2" v-if="order.warehouse_datetime">
            <b-col cols="2">
                <strong>Date Signed:</strong>
            </b-col>
            <b-col>{{ order.warehouse_datetime }}</b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'warehouse-signature',
    props: {
        order: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    methods: {},
    mounted() {},
    computed: {},
}
</script>

<style lang="scss" scoped>
</style>